import { ActionContext } from "vuex";
import { RootState } from "@/stores";
import PayService from "@/services/pay";

import { MerchantState } from "./index";
import { MerchantListItem } from "@/types";

import * as ServiceProto from "@/proto/pay/admin/all_pb";

export async function getMerchantList(
  { commit, rootState }: ActionContext<MerchantState, RootState>,
  data: {
    sort?: ServiceProto.OrderMap[keyof ServiceProto.OrderMap];
    keyword?: string;
    page?: number;
    limit?: number;
  } = {}
): Promise<MerchantListItem[]> {
  const {
    auth,
    config: { serviceUrl },
  } = rootState;

  const result = await new PayService(
    serviceUrl,
    auth.auth?.id_token as string
  ).getMerchants(data);

  commit("setMerchantList", result);

  return result;
}

export async function setMerchantStatus(
  { commit, rootState }: ActionContext<MerchantState, RootState>,
  data: {
    merchantId: string;
    status: boolean;
    type?: string;
    sourceBank?: string;
  }
) {
  const {
    auth,
    config: { serviceUrl },
  } = rootState;

  const payload: ServiceProto.UpdateMerchantRequest.AsObject = {
    merchantid: data.merchantId,
    status: data.status ? "Active" : "Inactive",
    type: data?.type ?? "",
    sourcebank: data?.sourceBank ?? "",
  };

  const result = await new PayService(
    serviceUrl,
    auth.auth?.id_token as string
  ).setMerchantStatus(payload);

  commit("setMerchantStatus", result);

  return result;
}
